import { createSelector } from '@reduxjs/toolkit'

import { selectMarketYoyGrowthExpectationState } from './selectMarketYoyGrowthExpectationState'

/** The full reference market list, independent of `records`. */
export const selectMarketYoyGrowthExpectationGeoMarkets = createSelector(
  [selectMarketYoyGrowthExpectationState],
  (state) => state.geoMarkets
)
